<template>
  <div style="display: none">
    {{ touch }}
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  export default {
    name: 'CheckTouch',
    computed: {
      ...mapGetters([
        'touch'
      ])
    },
    methods: {
      ...mapMutations([
        'setTouch'
      ]),
      $_setTouchStore () {
        document.body.removeEventListener('touchstart', this.$_setTouchStore)
        this.setTouch()
      }
    },
    mounted(){
      document.body.addEventListener('touchstart', this.$_setTouchStore)
    }
  }
</script>
